const SET_FULL_SCREEN = 'scratch-gui/mode/SET_FULL_SCREEN';
const SET_PLAYER = 'scratch-gui/mode/SET_PLAYER';
import {getHomeworkInfo} from '../lib/homework-info';

const initialState = {
    isFullScreen: false,
    isPlayerOnly: false
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SET_FULL_SCREEN:
        return {
            isFullScreen: action.isFullScreen,
            isPlayerOnly: state.isPlayerOnly
        };
    case SET_PLAYER:
        return {
            isFullScreen: state.isFullScreen,
            isPlayerOnly: action.isPlayerOnly
        };
    default:
        return state;
    }
};

const setFullScreen = function (isFullScreen) {
    let mode = isFullScreen ? 'fullscreen' : 'exit_fullscreen';
    const homeworkInfo = getHomeworkInfo();
    const courseId = Number(homeworkInfo.courseId);
    const unitId = Number(homeworkInfo.unitId);
    const lessonId = Number(homeworkInfo.lessonId);
    const oldStageMode = localStorage.getItem('stageDisplayMode');
    if (!isFullScreen) {
        mode = oldStageMode;
    }
    ht.track(`s3_stage_${mode}`, {
        context: {
            courseId: courseId,
            unitId: unitId,
            lessonId: lessonId,
            currentUrl: location.href,
            stageDisplayMode: `${mode}`
        }
    });
    return {
        type: SET_FULL_SCREEN,
        isFullScreen: isFullScreen
    };
};
const setPlayer = function (isPlayerOnly) {
    return {
        type: SET_PLAYER,
        isPlayerOnly: isPlayerOnly
    };
};

export {
    reducer as default,
    initialState as modeInitialState,
    setFullScreen,
    setPlayer
};
